import {ToastOptions} from 'ng6-toastr';

export class CustomOption extends ToastOptions {
    animate = 'flyLeft'; // 'fade', 'flyLeft' or 'flyRight'.
    newestOnTop = true;
    showCloseButton = true;
    maxShown = 100;
    toastLife = 3000;
}
